module.exports = __webpack_public_path__ + "img/vivobook_go.1555fe7c.png";